import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Hero from './components/Hero';
import Research from './components/Research';
import Integrations from './components/Integrations';
import About from './components/About';
import Contact from './components/Contact';

const NotFound = () => (
  <div className="min-h-screen flex items-center justify-center text-center px-6 pt-20">
    <div>
      <div className="text-7xl font-bold text-primary/30 mb-4">404</div>
      <h1 className="text-2xl font-bold mb-3">Page not found</h1>
      <p className="text-gray-400 mb-8">That page doesn't exist.</p>
      <a href="/" className="px-6 py-3 bg-primary hover:bg-blue-600 rounded-xl font-semibold text-sm transition-all">
        Go Home
      </a>
    </div>
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout><Hero /></Layout>} />
        <Route path="/research" element={<Layout><Research /></Layout>} />
        <Route path="/integrations" element={<Layout><Integrations /></Layout>} />
        <Route path="/about" element={<Layout><About /></Layout>} />
        <Route path="/contact" element={<Layout><Contact /></Layout>} />
        <Route path="*" element={<Layout><NotFound /></Layout>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
